import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";

export const MarketplaceService = {
	async getCorrelationId(): Promise<string> {
		const res = await ItiHttpService.get(API.centralizedAuth.marketplace.otc);
		return res.correlationId;
	},
};
